import { Modal, Button, Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import he from 'he';

export default function DataPrivacyConsentModal({ show, handleClose, onSave, initialData }) {
  const [content, setContent] = useState('');

  useEffect(() => {
    if (initialData?.content) {
      setContent(he.decode(initialData.content));
    } else {
      setContent('');
    }
  }, [initialData]);

  return (
    <Modal show={show} onHide={handleClose} size="lg" backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{initialData ? 'Edit' : 'Add'} Consent Form</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ height: '480px' }}>
        <Form>
          <Form.Group>
            <ReactQuill
              theme="snow"
              value={content}
              onChange={setContent}
              style={{ height: '400px'}}
            />
          </Form.Group>
        </Form>
      </Modal.Body>


      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Cancel</Button>
        <Button variant="primary" onClick={() => onSave({ content })}>Save</Button>
      </Modal.Footer>
    </Modal>


  );
}
